/**
 * Determine if the view is the scenePreview view
 */
export default function isScenePreview(store) {
  const { router } = (store || this.store).getState();

  return router.location.pathname.includes('/scene');
}
